import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { theme } from '@/theme';

type FullHeight = 'fullHeight';

export const Wrapper = styled(Box)<{
  height: number | FullHeight;
  noMargin?: boolean;
  verticalLoaderHeight?: number | FullHeight | '100vw';
  width?: number;
}>`
  display: flex;
  flex-direction: column;
  ${({ height, noMargin, verticalLoaderHeight, width }) => css`
    height: ${height === 'fullHeight' ? '100%' : `${height}px`};
    ${width && `width: ${width}px;`}
    ${verticalLoaderHeight !== undefined &&
    css`
      ${theme.media.md.down} {
        height: ${verticalLoaderHeight === 'fullHeight'
          ? '100%'
          : `${verticalLoaderHeight}`};
      }
    `}
    ${!noMargin &&
    css`
      margin: 0 auto;
    `}
  `}

  &:after,
    &:before {
    content: '';
    flex: 1;
  }
`;
